export type LocalOtaInfo = {
  version: number;
  builtAt?: string;
};

/**
 * Builtin bundle version counter (written into dist as /ota.json at pack time,
 * and kept under /ota/<tenant>/version.json in public/).
 */
export async function loadOtaInfo(): Promise<LocalOtaInfo | null> {
  const tenant = String(import.meta.env.VITE_TENANT_SLUG || 'vipso')
    .trim()
    .toLowerCase();
  const candidates = ['/ota.json', `/ota/${tenant}/version.json`];

  for (const path of candidates) {
    try {
      const res = await fetch(`${path}?t=${Date.now()}`, { cache: 'no-store' });
      if (!res.ok) continue;
      const data = (await res.json()) as { version?: number | string };
      const version = Number(data.version);
      if (!Number.isFinite(version)) continue;
      return { version, builtAt: (data as { builtAt?: string }).builtAt };
    } catch {
      // try next
    }
  }
  return null;
}
